/**
 * @generated SignedSource<<b94e8ee14cd36cf25e4f92c5fe3aff1d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PianofunclubEnrolmentModelStatusChoices = "ARCHIVED" | "ENROLED" | "OFFERED" | "WAITING_LIST" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type LoadEnrolments_query_enrolments$data = {
  readonly enrolments: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly adminNotes: string | null | undefined;
        readonly hasInvalidParentPhoneNumber: boolean;
        readonly id: string;
        readonly instrument: string | null | undefined;
        readonly lastOfferedTimestamp: string | null | undefined;
        readonly lessonStage: string | null | undefined;
        readonly parentEmail: string | null | undefined;
        readonly parentName: string | null | undefined;
        readonly parentPhoneNumber: string | null | undefined;
        readonly positionInWaitingList: number | null | undefined;
        readonly potentialDuplicatePupils: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly accountNumber: string | null | undefined;
              readonly id: string;
            } | null | undefined;
          } | null | undefined>;
        };
        readonly potentialDuplicates: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly pupilFirstName: string | null | undefined;
              readonly pupilLastName: string | null | undefined;
            } | null | undefined;
          } | null | undefined>;
        };
        readonly pupilFirstName: string | null | undefined;
        readonly pupilLastName: string | null | undefined;
        readonly pupilNotes: string | null | undefined;
        readonly school: {
          readonly archived: boolean;
          readonly id: string;
          readonly name: string;
        } | null | undefined;
        readonly schoolClass: string | null | undefined;
        readonly schoolYear: number | null | undefined;
        readonly status: PianofunclubEnrolmentModelStatusChoices;
      } | null | undefined;
    } | null | undefined>;
  } | null | undefined;
  readonly " $fragmentType": "LoadEnrolments_query_enrolments";
};
export type LoadEnrolments_query_enrolments$key = {
  readonly " $data"?: LoadEnrolments_query_enrolments$data;
  readonly " $fragmentSpreads": FragmentRefs<"LoadEnrolments_query_enrolments">;
};

import LoadEnrolmentsPaginationQuery_graphql from './LoadEnrolmentsPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "enrolments"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pupilFirstName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pupilLastName",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "excludeStatus"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "instrument"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "lessonStage"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "orderBy"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "pupil"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "schoolId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "schoolYear"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchTerm"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "status"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": LoadEnrolmentsPaginationQuery_graphql
    }
  },
  "name": "LoadEnrolments_query_enrolments",
  "selections": [
    {
      "alias": "enrolments",
      "args": [
        {
          "kind": "Variable",
          "name": "excludeStatus",
          "variableName": "excludeStatus"
        },
        {
          "kind": "Variable",
          "name": "instrument",
          "variableName": "instrument"
        },
        {
          "kind": "Variable",
          "name": "lessonStage",
          "variableName": "lessonStage"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "orderBy"
        },
        {
          "kind": "Variable",
          "name": "pupil",
          "variableName": "pupil"
        },
        {
          "kind": "Variable",
          "name": "schoolId",
          "variableName": "schoolId"
        },
        {
          "kind": "Variable",
          "name": "schoolYear",
          "variableName": "schoolYear"
        },
        {
          "kind": "Variable",
          "name": "searchTerm",
          "variableName": "searchTerm"
        },
        {
          "kind": "Variable",
          "name": "status",
          "variableName": "status"
        }
      ],
      "concreteType": "EnrolmentNodeConnection",
      "kind": "LinkedField",
      "name": "__LoadEnrolments_query_enrolments_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EnrolmentNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EnrolmentNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SchoolNode",
                  "kind": "LinkedField",
                  "name": "school",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "archived",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastOfferedTimestamp",
                  "storageKey": null
                },
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "schoolYear",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "schoolClass",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "instrument",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lessonStage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "parentName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "parentEmail",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "parentPhoneNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasInvalidParentPhoneNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pupilNotes",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "adminNotes",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "positionInWaitingList",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EnrolmentNodeConnection",
                  "kind": "LinkedField",
                  "name": "potentialDuplicates",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "EnrolmentNodeEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "EnrolmentNode",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v1/*: any*/),
                            (v2/*: any*/),
                            (v3/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProfileNodeConnection",
                  "kind": "LinkedField",
                  "name": "potentialDuplicatePupils",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProfileNodeEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ProfileNode",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v1/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "accountNumber",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "1ff4bcb61d18f4fe7fcdc0b1753e1cf3";

export default node;
